import { Outlet } from "react-router";
import Header from "../../../../../component/layout/header";
import useNav from "../../../../../script/tabingNavArray";

const AccountManagerLayout = () => {
  const navList = useNav();
  let { AccountManagerBottomHeader, OperationsTopHeader } = navList;
  return (
    <div className="webBody">
      <Header bottomTabs={AccountManagerBottomHeader} topTabs={OperationsTopHeader} />
      <Outlet />
    </div>
  );
};

export default AccountManagerLayout;
